export type WorkflowStageStatus = 'done' | 'next' | 'ready' | 'blocked';

export type WorkflowStage = {
  id: string;
  label: string;
  status: WorkflowStageStatus;
  detail: string;
  path: string;
};

export type WorkflowBlockerSeverity = 'info' | 'warning' | 'error';

export type WorkflowBlocker = {
  id: string;
  title: string;
  detail: string;
  severity: WorkflowBlockerSeverity;
  actionLabel?: string;
  actionPath?: string;
};

export type WorkflowActionTone = 'primary' | 'success' | 'warning';

export type WorkflowAction = {
  title: string;
  detail: string;
  label: string;
  path: string;
  tone?: WorkflowActionTone;
};

export function getStageChipColor(status: WorkflowStageStatus): 'success' | 'warning' | 'info' | 'default' {
  if (status === 'done') return 'success';
  if (status === 'next') return 'warning';
  if (status === 'ready') return 'info';
  return 'default';
}

export function getStageLabel(status: WorkflowStageStatus): string {
  if (status === 'done') return 'Done';
  if (status === 'next') return 'Next';
  if (status === 'ready') return 'Ready';
  return 'Blocked';
}

export function getBlockerAlertSeverity(
  severity: WorkflowBlockerSeverity
): 'info' | 'warning' | 'error' {
  if (severity === 'error') return 'error';
  if (severity === 'warning') return 'warning';
  return 'info';
}

export function pickPrimaryAction(
  stages: WorkflowStage[],
  fallback: WorkflowAction
): WorkflowAction {
  const nextStage = stages.find((stage) => stage.status === 'next');
  if (nextStage) {
    return {
      title: nextStage.label,
      detail: nextStage.detail,
      label: `Open ${nextStage.label}`,
      path: nextStage.path,
      tone: 'warning',
    };
  }

  const readyStage = stages.find((stage) => stage.status === 'ready');
  if (readyStage) {
    return {
      title: readyStage.label,
      detail: readyStage.detail,
      label: `Open ${readyStage.label}`,
      path: readyStage.path,
      tone: 'primary',
    };
  }

  return fallback;
}
